module.exports = __webpack_public_path__ + "img/fa-brands-400.75af8363.svg";